import Vue from 'vue';
import { UserRoles } from '@/enums';
import { Filters, SimpleEnumType } from '@/types';

export interface SimpleObjectSlug {
  id: number,
  name: string,
  slug: string,
}

interface Permission extends SimpleObjectSlug {
  is_allowed: boolean
}

export namespace Staffs {
  export enum Pages {
    STAFFS = 'staffs',
    STAFF_DETAIL = 'staff',
    STAFF_EDIT = 'staff/edit',
    STAFF_CERTIFICATES = 'certificates',
    SERTIFICATES_STAFF = 'certificates_staff'
  }

  export interface Staff {
    [key: string]: unknown,
    id?: number,
    surname: string | null,
    name: string | null,
    patronymic: string | null,
    full_name?: string | null, // склеенные ФИО
    email: string,
    telephone: string,
    birth_date?: string | null,
    company_name?: string | null, // название компании
    city: string,
    partner_code: string,
    is_active: boolean,
    is_veryfied: boolean,
    is_active_account: boolean,
    is_registered: boolean,
    is_detached: boolean,
    roles: SimpleEnumType<UserRoles.Internal>[],
    roles_string?: string, // роли склеенные через запятую
    verification_date: string | null, // Дата окончания действия учетной записи
    created_at: string,
    image?: string | File | null,
    permissions?: Permission[];
    is_allowed_edit_permissions?: boolean;
    is_incompatible_roles: boolean;
    compatible_roles: string[];
    job_rank?: string | null;
  }
  export type Course = SimpleObjectSlug

  export type CourseType = SimpleObjectSlug

  export interface StaffCerts {
    [key: string]: unknown,
    id: number,
    cert_validity: string,
    user_id: number,
    surname: string,
    name: string,
    course: Course,
    course_type: CourseType,
    evented_date: string,
    expiry_date: string,
    result: string,
    paid: string,
    external_id: string,
  }
  export interface StaffCertsUsers {
    id: number
    full_name: string | null;
  }

  export interface StaffCertsUsersCategories {
    id: number
    name: string | null;
  }

  export interface StaffCertsUsersCourses {
    id: number
    name: string | null;
  }

  export interface CourseStatistic {
    course_id: number,
    course_name: string,
    quantity_valid: number,
    quantity_expired: number,
  }

  export interface StaffStatistic {
    id: number,
    type_name: string,
    quantity_valid: number,
    quantity_expired: number,
    courses: CourseStatistic[]
  }

  export interface ChangingInfo {
    staff_id: number,
    code: number | null,
  }

  export interface CompatibleRoles {
    value: string;
    text: string;
    disabled: boolean;
  }

}

export interface InviteUserData {
  [key: string]: string | UserRoles.Internal[] | undefined | null,
  email: string,
  roles: UserRoles.Internal[] | null,
  city?: string,
}

export interface StaffsFilters extends Filters {
  [key: string]: unknown,
  search: string,
  role: UserRoles.Internal[],
  status: boolean | null,
  city: string,
}

export interface StaffsCertsFilters {
  [key: string]: unknown,
  course_category_id: string
  course_id: string
  user_id: string
  cert_validity: string
}

export interface StaffStatisticFilters {
  [key: string]: unknown,
}

export interface StaffActivityPayload {
  id: number,
  is_veryfied?: boolean,
  verification_date?: string,
}

export type ActivityDialog = Vue & {
  open_dialog: (id: null | number) => Promise<false | string>,
}

export interface CompatibleRolesFilter {
  roles: string[] | unknown
}
